import { render, staticRenderFns } from "./class-stu-update.vue?vue&type=template&id=3f3d6140&"
import script from "./class-stu-update.vue?vue&type=script&lang=js&"
export * from "./class-stu-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports